import { useConst } from "@chakra-ui/react";
import { AsyncReturnType } from "type-fest";

import { TypeaheadService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";
import { gen, repeat } from "@/utils";

type QueryFnData = AsyncReturnType<typeof TypeaheadService.getLanguages>;
type Error = unknown;

const queryKey = () => ["typeahead", "languages"];

export const useLanguages = <TData = QueryFnData>(
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const result = useQuery<QueryFnData, Error, TData>(
    queryKey(),
    () => TypeaheadService.getLanguages(),
    {
      skeletonData: useConst({
        elements: repeat(gen.typeahead),
        pagination: {
          skip: 0,
          limit: 10,
          total: 2,
        },
      }),
      ...options,
    }
  );

  return result;
};

useLanguages.queryKey = queryKey;
